import isUndefined from "lodash/isUndefined";

type TEnvironment = "development" | "production";

export const getEnvironment = (): TEnvironment => {
  if (isUndefined(window)) {
    return "development";
  }
  const currentUrl = window.location.hostname;

  if (currentUrl === "localhost") {
    return "development";
  }

  return "production";
};
